import React from 'react';
import classNames from 'classnames';

import lang from '../../lib/language';
import { RatiosPeriodType } from '../../lib/models/fundamental/types';

import styles from './RatiosPeriodButtons.module.scss';

type Props = {
    currentPeriod: string;
    setPeriod: (period: RatiosPeriodType) => void;
}

const RatiosPeriodButtons = (props: Props) => {
  const { currentPeriod, setPeriod } = props;

  return (
    <div className={styles.periodButtons}>
      <button
        className={classNames(styles.periodBtn, { [styles.activeBtn]: currentPeriod === RatiosPeriodType.ANNUAL })}
        onClick={() => setPeriod(RatiosPeriodType.ANNUAL)}
        type="button"
      >
        {lang.financialsAnnualOption()}
      </button>
      <button
        className={classNames(styles.periodBtn, {
          [styles.activeBtn]: currentPeriod === RatiosPeriodType.QUARTERLY })}
        onClick={() => setPeriod(RatiosPeriodType.QUARTERLY)}
        type="button"
      >
        {lang.financialsQuarterlyOption()}
      </button>
      <button
        className={classNames(styles.periodBtn, { [styles.activeBtn]: currentPeriod === RatiosPeriodType.TTM })}
        onClick={() => setPeriod(RatiosPeriodType.TTM)}
        type="button"
      >
        {RatiosPeriodType.TTM}
      </button>
    </div>
  );
};

export default RatiosPeriodButtons;
